import { useSearchParams } from 'react-router-dom'
import uploadDocumentService, { Asset } from '../services/upload-documents'
import { useTranslation } from 'react-i18next'

export type UploadStepConfig = {
  model: string
  urlName: string | null
  title: string
  description: string
}

export function useUploadDocuments() {
  const [searchParams] = useSearchParams()
  const { t } = useTranslation()
  const oId = searchParams.get('oId')
  const sId = searchParams.get('sId')
  const operationUploadSteps = searchParams.getAll('uploadSteps')

  const DOCUMENT_UPLOAD_STEPS: UploadStepConfig[] = [
    {
      model: 'WELCOME',
      urlName: null,
      title: t('WELCOME'),
      description: t('WELCOME_DESCRIPTION')
    },
    {
      model: 'ANVDNI',
      urlName: null,
      title: t('ANVDNI_TITLE'),
      description: t('ANVDNI_DESCRIPTION')
    },
    {
      model: 'REVDNI',
      urlName: null,
      title: t('REVDNI_TITLE'),
      description: t('REVDNI_DESCRIPTION')
    },
    {
      model: 'BANKRECEIPT',
      urlName: 'bankreceipt',
      title: t('BANKRECEIPT_TITLE'),
      description: t('BANKRECEIPT_DESCRIPTION')
    },
    {
      model: 'CUSTOMUPLOAD_01',
      urlName: 'customUpload01',
      title: t('CUSTOMUPLOAD_01_TITLE'),
      description: t('CUSTOMUPLOAD_01_DESCRIPTION')
    },
    {
      model: 'ANVMOBILE',
      urlName: 'anvmobile',
      title: 'Anverso del Móvil',
      description: 'Texto de descripción para el anverso del móvil'
    },
    {
      model: 'REVMOBILE',
      urlName: 'revmobile',
      title: 'Reverso del Móvil',
      description: 'Texto de descripción para el reverso del móvil'
    }
  ]

  const createUploadStepSequence = (): UploadStepConfig[] => {
    const mandatoryModels = ['WELCOME', 'ANVDNI', 'REVDNI']

    return DOCUMENT_UPLOAD_STEPS.filter(
      (step) =>
        mandatoryModels.includes(step.model) ||
        (step.urlName && operationUploadSteps.some(
          (uploadStep) => uploadStep.trim().toLowerCase() === step.urlName?.trim().toLowerCase()
        ))
    )
  }

  const stepsSequence = createUploadStepSequence()

  const sendDocument = async (body: Partial<Asset>) => {
    if (!oId || !sId) {
      throw new Error('oId and sId are required')
    }

    const uploadAssetPayload: Asset = {
      id: `${oId}@${sId}`,
      timestamp: Date.now(),
      name: body.name || '',
      mime: body.mime || '',
      ext: body.ext || '',
      content: body.content || '',
      model: body.model || ''
    }

    return await uploadDocumentService.sendDocument(uploadAssetPayload)
  }

  return { sendDocument, operationUploadSteps, stepsSequence }
}
